import { CheckIcon } from "@heroicons/react/24/solid";
import React from "react";

interface RebootLiveStepperProps {
  currentStep: number;
  steps: string[];
}

export const RebootLiveStepper: React.FC<RebootLiveStepperProps> = ({
  currentStep,
  steps,
}) => {
  return (
    <div className="box-border content-stretch flex flex-col gap-[10px] items-center px-[17px] py-[19px] relative shrink-0 w-full">
      <div className="relative w-full max-w-[800px]">
        {/* Progress line background */}
        <div className="absolute left-[20px] top-[39px] right-[20px]">
          <div className="size-full">
            <div className="box-border content-stretch flex flex-col items-start relative w-full">
              <div className="bg-[#2a2a2a] h-[2px] shrink-0 w-full relative">
                {/* Progress line fill */}
                <div
                  className="bg-[#fb6a07] h-[2px] absolute left-0 top-0 transition-all duration-500 ease-out"
                  style={{
                    width: `${((currentStep - 1) / (steps.length - 1)) * 100}%`,
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Step indicators */}
        <div className="content-stretch flex items-start justify-between relative shrink-0 w-full">
          {steps.map((step, index) => {
            const stepNumber = index + 1;
            const isActive = stepNumber === currentStep;
            const isCompleted = stepNumber < currentStep;

            return (
              <div
                key={index}
                className="content-stretch flex flex-col gap-[8px] items-center relative shrink-0"
              >
                <div
                  className={`relative rounded-[2.7962e+07px] shrink-0 size-[40px] transition-all duration-300 ${
                    isActive
                      ? "bg-[#fb6a07] shadow-[0px_0px_0px_4px_rgba(251,106,7,0.2)]"
                      : isCompleted
                        ? "bg-[#fb6a07]"
                        : "bg-[#1d1d1f]"
                  }`}
                  style={{ marginTop: "20px" }}
                >
                  {!isCompleted && (
                    <div
                      aria-hidden="true"
                      className="absolute border-[#2a2a2a] border-[1.667px] border-solid inset-0 pointer-events-none rounded-[2.7962e+07px]"
                    />
                  )}
                  <div className="bg-clip-padding border-0 border-transparent border-solid box-border content-stretch flex items-center justify-center relative size-[40px]">
                    {isCompleted ? (
                      <CheckIcon className="w-5 h-5 text-white" />
                    ) : (
                      <p
                        className={`font-semibold leading-[24px] text-[16px] ${
                          isActive ? "text-white" : "text-[#b6b2b2]"
                        }`}
                      >
                        {stepNumber}
                      </p>
                    )}
                  </div>
                </div>
                <div className="bg-clip-padding border-0 border-transparent border-solid box-border content-stretch flex gap-[10px] items-center justify-center relative">
                  <p
                    data-testid={`reboot-live-stepper-step-${stepNumber}`}
                    className={`leading-[16px] text-[12px] text-center transition-colors duration-300 ${
                      isActive
                        ? "font-bold text-white"
                        : "font-normal text-[#b6b2b2]"
                    }`}
                  >
                    {step}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
